exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flexCol {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 10px;\n    max-width: 100%;\n}\n\nimg {\n    border-radius: 5px;\n    max-width: 55%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/home-engineering-coding/home-engineering-coding.component.css
// module id = ../../../../../src/app/home-engineering-coding/home-engineering-coding.component.css
// module chunks = main